import { jsonInit } from '../fetch/fetchFunctions';
import { displayError } from '../animations/message';
import { MarkedNumber, Header, Batch, Publication, UserInfo } from './model';

export class TidingsClientBase {

    public isInternal(): boolean {
        return false;
    }

    public async getUserInfo(): Promise<UserInfo> {
        return Promise.resolve({ Name: 'Ukendt bruger', IsAccessAllowed : false } as UserInfo);
    }

    public async getYearsByPublicationType(publicationType: string, postFix = ''): Promise<MarkedNumber[]> {

        try {
            let response = await fetch(`./odata/Batch/Tidings.GetDistinctYearsByPublicationType(publicationType='${publicationType}')`+postFix, jsonInit('get'));

            if (response.status === 200) {
                let resultJson = await response.json();
                return (resultJson.value as number[]).map(n => ({ number: n, isAdditional: postFix !== '' } as MarkedNumber));
            } else {
                displayError('Kunne ikke hente &aring;rstal', await response.text());
            }
        } catch (e) {
            displayError('Kunne ikke hente &aring;rstal', e);
        }
        return [];
    }

    public async getIssuesByPublicationTypeAndYear(publicationType: string, year: number, postFix = ''): Promise<MarkedNumber[]> {

        try {

            let response = await fetch(`./odata/Batch?$filter=PublicationType eq '${publicationType}' and Year eq ${year}` + postFix, jsonInit('get'));

            if (response.status === 200) {
                let resultJson = await response.json();

                return (resultJson.value as Batch[]).map(b => ({ number: b.Number, isAdditional: postFix !== '' } as MarkedNumber)).reverse();
            } else {
                displayError('Kunne ikke hente publiceringer', await response.text());
            }
        } catch (e) {
            displayError('Kunne ikke hente publiceringer', e);
        }
        return [];
    }


    public async getPublicationsByPublicationTypeYearAndIssue(publicationType: string, year: number, issue: number, postFix = ''): Promise<Header[]> {
        let headerFilter = `$filter=Publications/any(p:p/Batch/Year eq ${year} and p/Batch/Number eq ${issue} and p/Batch/PublicationType eq '${publicationType}')&$orderby=Order`;
        let publicationFilter = `$filter=Batch/Year eq ${year} and Batch/Number eq ${issue} and Batch/PublicationType eq '${publicationType}'`;
        let expand = `$expand=Publications(${publicationFilter};$orderby=PublicationTime;$expand=Batch,Fields($orderby=Order;$expand=Headers($select=UniqueId,OrderByFieldId,MultiValueSeparator,CustomFormat),Images($orderby=Reference;$select=Id,ImageFormat,Reference);$select=Id,ContentId,Inid,Label,Text,Order))`;

        try {   

            let response = await fetch(`./odata/Header?${headerFilter}&${expand}&orderby=Order` + postFix, jsonInit('get'));
            
            if (response.status === 200) {
                let resultJson = await response.json();
                return resultJson.value;
            } else {
                displayError('Kunne ikke hente publiceringen', await response.text());
            }
        } catch (e) {
            displayError('Kunne ikke hente publiceringen', e);
        }
        return [];
    }

    public async getBatchByPublicationTypeYearAndIssue(publicationType: string, year: number, issue: number, postFix = ''): Promise<Batch[]> {
        let batchFilter = `$filter=Year eq ${year} and Number eq ${issue} and PublicationType eq '${publicationType}'`;

        try {
            let response = await fetch(`./odata/Batch?${batchFilter}` + postFix, jsonInit('get'));
            
            if (response.status === 200) {
                let resultJson = await response.json();
                return resultJson.value;
            } else {
                displayError('Kunne ikke hente nummer', await response.text());
            }
        } catch (e) {
            displayError('Kunne ikke hente nummer', e);
        }

        return [];
    }

    public async approve(publication: Publication): Promise<Publication> {
        return publication;
    }

    public async reject(publication: Publication): Promise<Publication> {
        return publication;
    }

}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./Frontend/src/Tidings/tidingsClientBase.ts